import axios from "axios";

const baseURL = `${process.env.REACT_APP_API_ENDPOINT_URL}/web/v3`;

export const publicApi = axios.create({
  baseURL,
});
